/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   Thu June 15 2021 14:30:00 PM
 *
 *******************************************************/
//flow
import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';
import { disableInstallStatusForDashboardV4 } from 'src/helpers/dashboard-helper';
import loadingIcon from 'src/assets/images/dashboard-v3/loading-icon.png';

type Props = {
  syncStatus: string,
  themeInstallStatus: string,
  isOnboardingV3: boolean
};

type ComposedProps = Props & WithI18nProps;

class InstallationRemindStatusBanner extends Component<ComposedProps> {
  render() {
    const {
      i18n,
      syncStatus,
      themeInstallStatus,
      isOnboardingV3,
      showInstallationSuccessBanner,
      userAppVersion,
      isDisableInstallStatus
    } = this.props;
    if (!isOnboardingV3 || userAppVersion !== 'v3' || isDisableInstallStatus) return <></>;

    const hideSyncBanner =
      (!syncStatus && !themeInstallStatus) ||
      (syncStatus === 'done' && themeInstallStatus !== 'running') ||
      !showInstallationSuccessBanner;

    return (
      <>
        {!hideSyncBanner && (
          <>
            <div className="BC-InstallationStatus__ChildPage">
              <div className="icon-status">
                <img src={loadingIcon} alt="loadingIcon" width={18} height={18} />
              </div>
              <div className="info-status">
                <div>
                  {i18n.translate('AdminHTML.DashboardV3.InstallStatusBanner.labelProcessing')}
                </div>
              </div>
            </div>
          </>
        )}
      </>
    );
  }
}

const mapStateToProps = (state, props) => {
  const syncStatus = _.get(state.install, 'syncStatus');
  const themeInstallStatus = _.get(state.install, 'installStatus');

  const tenantApp = _.get(state.oauth, 'tenantApp', {});
  const isOnboardingV3 = _.get(tenantApp, 'settings.onboardingV3.settings.enable', false);
  const userAppVersion = _.get(tenantApp, 'userAppVersion', '');
  const showInstallationSuccessBanner = _.get(
    tenantApp,
    'settings.onboardingV3.settings.showInstallationSuccessBanner',
    false
  );
  const isDisableInstallStatus = disableInstallStatusForDashboardV4(tenantApp);

  return {
    syncStatus,
    themeInstallStatus,
    isOnboardingV3,
    showInstallationSuccessBanner,
    userAppVersion,
    isDisableInstallStatus
  };
};

const mapDispatchToProps = (dispatch, ownProps) => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withI18n()(InstallationRemindStatusBanner));
